var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "asc__insertPage" },
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "6" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "6" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "investmentForm" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        {
          staticClass: "asc__insertPage-content-head",
          attrs: { cols: "12" },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.tabValidation()
            }
          }
        },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t("insert.investmentForm.customer"),
                        error: _vm.$v.form.CustomerId,
                        md: "3",
                        lg: "3",
                        "show-copy": "",
                        "copy-values": "Code,Description1"
                      }
                    },
                    [
                      _c("NextDropdown", {
                        attrs: {
                          url:
                            "VisionNextCustomer/api/Customer/AutoCompleteSearch",
                          searchable: true,
                          "custom-option": true,
                          "or-condition-fields": "Description1,CommercialTitle",
                          "dynamic-and-condition": { StatusIds: [1] },
                          "is-customer": true,
                          disabled: true
                        },
                        on: {
                          change: function($event) {
                            return _vm.selectedCustomer()
                          },
                          input: function($event) {
                            return _vm.selectedSearchType("CustomerId", $event)
                          }
                        },
                        model: {
                          value: _vm.selectedCustomer,
                          callback: function($$v) {
                            _vm.selectedCustomer = $$v
                          },
                          expression: "selectedCustomer"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t("insert.investmentForm.customerName")
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          disabled: true,
                          type: "text",
                          md: "3",
                          lg: "3"
                        },
                        model: {
                          value: _vm.form.CustomerName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "CustomerName", $$v)
                          },
                          expression: "form.CustomerName"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: { title: _vm.$t("insert.investmentForm.address") }
                    },
                    [
                      _c("NextTextArea", {
                        attrs: { md: "3", lg: "3", disabled: true },
                        model: {
                          value: _vm.form.Address,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Address", $$v)
                          },
                          expression: "form.Address"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t("insert.investmentForm.licenseNumber")
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          md: "3",
                          lg: "3",
                          disabled: true
                        },
                        model: {
                          value: _vm.form.LicenseNumber,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "LicenseNumber", $$v)
                          },
                          expression: "form.LicenseNumber"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t("insert.investmentForm.description"),
                        error: _vm.$v.form.Description1,
                        required: true
                      }
                    },
                    [
                      _c("NextTextArea", {
                        attrs: { md: "3", lg: "3" },
                        model: {
                          value: _vm.form.Description1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Description1", $$v)
                          },
                          expression: "form.Description1"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t("insert.investmentForm.typeId"),
                        md: "3",
                        lg: "3"
                      }
                    },
                    [
                      _c("NextDropdown", {
                        attrs: {
                          url: "VisionNextContract/api/ContractType/Search",
                          disabled: true
                        },
                        model: {
                          value: _vm.form.ContractTypeDesc,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "ContractTypeDesc", $$v)
                          },
                          expression: "form.ContractTypeDesc"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    { attrs: { title: _vm.$t("insert.investmentForm.route") } },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          md: "3",
                          lg: "3",
                          disabled: true
                        },
                        model: {
                          value: _vm.form.Route,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Route", $$v)
                          },
                          expression: "form.Route"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t("insert.investmentForm.tmrSrName")
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          md: "3",
                          lg: "3",
                          disabled: true
                        },
                        model: {
                          value: _vm.form.TmrSrName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "TmrSrName", $$v)
                          },
                          expression: "form.TmrSrName"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: { title: _vm.$t("insert.investmentForm.formDate") }
                    },
                    [
                      _c("NextDatePicker", {
                        attrs: { disabled: true },
                        model: {
                          value: _vm.form.FormDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "FormDate", $$v)
                          },
                          expression: "form.FormDate"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t("insert.investmentForm.salesVolumeClass")
                      }
                    },
                    [
                      _c("NextDropdown", {
                        attrs: { disabled: true, md: "3", lg: "3" },
                        model: {
                          value: _vm.form.SalesVolumeClass,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "SalesVolumeClass", $$v)
                          },
                          expression: "form.SalesVolumeClass"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t("insert.investmentForm.customerArea"),
                        md: "3",
                        lg: "3"
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          md: "3",
                          lg: "3",
                          disabled: true
                        },
                        model: {
                          value: _vm.form.CustomerArea,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "CustomerArea", $$v)
                          },
                          expression: "form.CustomerArea"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        title: _vm.$t("insert.investmentForm.signingType"),
                        error: _vm.$v.form.SignatureType,
                        required: true,
                        md: "3",
                        lg: "3"
                      }
                    },
                    [
                      _c("NextDropdown", {
                        attrs: {
                          "lookup-key": "SIGNATURE_TYPE",
                          "get-lookup": true
                        },
                        on: {
                          input: function($event) {
                            return _vm.getSignatureType($event)
                          }
                        },
                        model: {
                          value: _vm.form.SignatureType,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "SignatureType", $$v)
                          },
                          expression: "form.SignatureType"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("insert.investmentForm.currentInvestment"),
                    active: ""
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.tabValidation()
                    }
                  }
                },
                [
                  _c(
                    "fieldset",
                    { staticClass: "fs-border" },
                    [
                      _c("legend", { staticClass: "fs-legend-detail" }, [
                        _vm._v(
                          _vm._s(_vm.$t("insert.investmentForm.contractDates"))
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "p-1" },
                        [
                          _c(
                            "b-col",
                            { staticClass: "mr-1", attrs: { cols: "6" } },
                            [
                              _c(
                                "NextFormGroup",
                                {
                                  attrs: {
                                    title: _vm.$t(
                                      "insert.investmentForm.contractStartDate"
                                    )
                                  }
                                },
                                [
                                  _c("NextDatePicker", {
                                    attrs: { disabled: true },
                                    model: {
                                      value:
                                        _vm.contractDates
                                          .ContractValidDateStartDate,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.contractDates,
                                          "ContractValidDateStartDate",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "contractDates.ContractValidDateStartDate"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "mr-1", attrs: { cols: "6" } },
                            [
                              _c(
                                "NextFormGroup",
                                {
                                  attrs: {
                                    title: _vm.$t(
                                      "insert.investmentForm.contractEndDate"
                                    )
                                  }
                                },
                                [
                                  _c("NextDatePicker", {
                                    attrs: { disabled: true },
                                    model: {
                                      value:
                                        _vm.contractDates
                                          .ContractValidDateEndDate,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.contractDates,
                                          "ContractValidDateEndDate",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "contractDates.ContractValidDateEndDate"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "mr-1", attrs: { cols: "6" } },
                            [
                              _c(
                                "NextFormGroup",
                                {
                                  attrs: {
                                    title: _vm.$t(
                                      "insert.investmentForm.contractDuration"
                                    )
                                  }
                                },
                                [
                                  _c("NextInput", {
                                    attrs: { type: "text", disabled: true },
                                    model: {
                                      value:
                                        _vm.daysDifferenceCurrentInvestment,
                                      callback: function($$v) {
                                        _vm.daysDifferenceCurrentInvestment = $$v
                                      },
                                      expression:
                                        "daysDifferenceCurrentInvestment"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "fieldset",
                    { staticClass: "fs-border" },
                    [
                      _c("legend", { staticClass: "fs-legend-detail" }, [
                        _vm._v(
                          _vm._s(_vm.$t("insert.investmentForm.currentSales"))
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "p-3" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "b-table-simple",
                                { attrs: { bordered: "", small: "" } },
                                [
                                  _c(
                                    "b-thead",
                                    [
                                      _c("b-th"),
                                      _vm._v(" "),
                                      _c("b-th", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                this.currentSales.KentBrandLC
                                              )
                                            )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("b-th", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                this.currentSales
                                                  .RothmansBrandLC
                                              )
                                            )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("b-th", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                this.currentSales
                                                  .Tekel2000BrandLC
                                              )
                                            )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("b-th", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "insert.investmentForm.total"
                                              )
                                            )
                                          )
                                        ])
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-tbody",
                                    [
                                      _c(
                                        "b-tr",
                                        [
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.investmentForm.currentMonthlyAverageSale"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                this.currentSales.KentNetSales
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                this.currentSales
                                                  .RothmansNetSales
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                this.currentSales
                                                  .Tekel2000NetSales
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                this.currentSales.KentNetSales +
                                                  this.currentSales
                                                    .RothmansNetSales +
                                                  this.currentSales
                                                    .Tekel2000NetSales
                                              ) + " "
                                            )
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-tr",
                                        [
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.investmentForm.currentAnnualSaleProfit"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                this.currentSales.KentNetSales *
                                                  this.GrossMargin
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                this.currentSales
                                                  .RothmansNetSales *
                                                  this.GrossMargin
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                this.currentSales
                                                  .Tekel2000NetSales *
                                                  this.GrossMargin
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                this.currentSales.KentNetSales *
                                                  this.GrossMargin +
                                                  this.currentSales
                                                    .RothmansNetSales *
                                                    this.GrossMargin +
                                                  this.currentSales
                                                    .Tekel2000NetSales *
                                                    this.GrossMargin
                                              ) + " "
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "fieldset",
                    { staticClass: "fs-border" },
                    [
                      _c("legend", { staticClass: "fs-legend-detail" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "insert.investmentForm.currentInvestmentBudget"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "p-3" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "b-table-simple",
                                { attrs: { bordered: "", small: "" } },
                                [
                                  _c(
                                    "b-thead",
                                    [
                                      _c("b-th", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "insert.investmentForm.contractGainType"
                                              )
                                            )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("b-th", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "insert.investmentForm.earningAmount"
                                              )
                                            )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("b-th", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "insert.investmentForm.earningsTypeBudget"
                                              )
                                            )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("b-th", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "insert.contract.plannedPaymentDate"
                                              )
                                            )
                                          )
                                        ])
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-tbody",
                                    [
                                      _c(
                                        "b-tr",
                                        [
                                          _c("b-td", [_vm._v("Nakit")]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                this.currentInvestmentBudgetCash
                                                  .Cash
                                                  ? this
                                                      .currentInvestmentBudgetCash
                                                      .Cash
                                                  : "-----"
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                this.currentInvestmentBudgetCash
                                                  .cashBudgetMaster
                                                  ? this
                                                      .currentInvestmentBudgetCash
                                                      .cashBudgetMaster
                                                  : "-----"
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                this.currentInvestmentBudgetCash
                                                  .cashScheduledPaymentDate
                                                  ? this
                                                      .currentInvestmentBudgetCash
                                                      .cashScheduledPaymentDate
                                                  : "-----"
                                              )
                                            )
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-tr",
                                        [
                                          _c("b-td", [_vm._v("Only DTI")]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                this.currentInvestmentBudgetDTI
                                                  .OnlyDTI
                                                  ? this
                                                      .currentInvestmentBudgetDTI
                                                      .OnlyDTI
                                                  : "-----"
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                this.currentInvestmentBudgetDTI
                                                  .dtiBudgetMaster
                                                  ? this
                                                      .currentInvestmentBudgetDTI
                                                      .dtiBudgetMaster
                                                  : "-----"
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td")
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-tr",
                                        [
                                          _c("b-td", [_vm._v("YYM")]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                this.currentInvestmentBudgetYYM
                                                  .Yym
                                                  ? this
                                                      .currentInvestmentBudgetYYM
                                                      .Yym
                                                  : "-----"
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                this.currentInvestmentBudgetYYM
                                                  .yymBudgetMaster
                                                  ? this
                                                      .currentInvestmentBudgetYYM
                                                      .yymBudgetMaster
                                                  : "-----"
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td")
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-tr",
                                        [
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.investmentForm.total"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                this.currentInvestmentBudgetCash
                                                  .Cash +
                                                  this
                                                    .currentInvestmentBudgetDTI
                                                    .OnlyDTI +
                                                  this
                                                    .currentInvestmentBudgetYYM
                                                    .Yym
                                              )
                                            ),
                                            _c("span", [_c("b-td")], 1)
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td"),
                                          _vm._v(" "),
                                          _c("b-td")
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "fieldset",
                    { staticClass: "fs-border" },
                    [
                      _c("legend", { staticClass: "fs-legend-detail" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "insert.investmentForm.currentReturnOnInvestment"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "p-3" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "b-table-simple",
                                { attrs: { bordered: "", small: "" } },
                                [
                                  _c(
                                    "b-tbody",
                                    [
                                      _c(
                                        "b-tr",
                                        [
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.investmentForm.currentReturnOnInvestmentTL"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                this.currentSales.KentNetSales *
                                                  this.GrossMargin +
                                                  this.currentSales
                                                    .RothmansNetSales *
                                                    this.GrossMargin +
                                                  this.currentSales
                                                    .Tekel2000NetSales *
                                                    this.GrossMargin -
                                                  (this.currentInvestmentBudget
                                                    .KentContractQuotaQuantity +
                                                    this.currentInvestmentBudget
                                                      .RothmansContractQuotaQuantity +
                                                    this.currentInvestmentBudget
                                                      .Tekel2000ContractQuotaQuantity)
                                              )
                                            )
                                          ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-tr",
                                        [
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.investmentForm.rateOfReturnOnInvestment"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                (this.currentSales
                                                  .KentNetSales *
                                                  this.GrossMargin +
                                                  this.currentSales
                                                    .RothmansNetSales *
                                                    this.GrossMargin +
                                                  this.currentSales
                                                    .Tekel2000NetSales *
                                                    this.GrossMargin) /
                                                  (this.currentInvestmentBudget
                                                    .KentContractQuotaQuantity +
                                                    this.currentInvestmentBudget
                                                      .RothmansContractQuotaQuantity +
                                                    this.currentInvestmentBudget
                                                      .Tekel2000ContractQuotaQuantity)
                                              )
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("insert.investmentForm.newInvestment")
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.tabValidation()
                    }
                  }
                },
                [
                  _c(
                    "fieldset",
                    { staticClass: "fs-border" },
                    [
                      _c("legend", { staticClass: "fs-legend-detail" }, [
                        _vm._v(
                          _vm._s(_vm.$t("insert.investmentForm.contractDates"))
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "p-1" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "NextFormGroup",
                                {
                                  attrs: {
                                    title: _vm.$t(
                                      "insert.investmentForm.contractStartDate"
                                    ),
                                    error: _vm.$v.validDates.contractStartDate,
                                    required: true
                                  }
                                },
                                [
                                  _c("NextDatePicker", {
                                    model: {
                                      value: _vm.validDates.contractStartDate,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.validDates,
                                          "contractStartDate",
                                          $$v
                                        )
                                      },
                                      expression: "validDates.contractStartDate"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "mr-1", attrs: { cols: "6" } },
                            [
                              _c(
                                "NextFormGroup",
                                {
                                  attrs: {
                                    title: _vm.$t(
                                      "insert.investmentForm.contractEndDate"
                                    ),
                                    error: _vm.$v.validDates.contractEndDate,
                                    required: true
                                  }
                                },
                                [
                                  _c("NextDatePicker", {
                                    model: {
                                      value: _vm.validDates.contractEndDate,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.validDates,
                                          "contractEndDate",
                                          $$v
                                        )
                                      },
                                      expression: "validDates.contractEndDate"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "NextFormGroup",
                                {
                                  attrs: {
                                    title: _vm.$t(
                                      "insert.investmentForm.contractDuration"
                                    )
                                  }
                                },
                                [
                                  _c("NextInput", {
                                    attrs: { disabled: true, type: "text" },
                                    model: {
                                      value: _vm.daysDifferenceNewInvestment,
                                      callback: function($$v) {
                                        _vm.daysDifferenceNewInvestment = $$v
                                      },
                                      expression: "daysDifferenceNewInvestment"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "fieldset",
                    { staticClass: "fs-border" },
                    [
                      _c("legend", { staticClass: "fs-legend-detail" }, [
                        _vm._v(
                          _vm._s(_vm.$t("insert.investmentForm.targetSale"))
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "p-3" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "b-table-simple",
                                { attrs: { bordered: "", small: "" } },
                                [
                                  _c(
                                    "b-thead",
                                    [
                                      _c("b-th"),
                                      _vm._v(" "),
                                      _c("b-th", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                this.targetSale
                                                  .KentBrandContractItem
                                              )
                                            )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("b-th", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                this.targetSale
                                                  .RothmansBrandContractItem
                                              )
                                            )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("b-th", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                this.targetSale
                                                  .Tekel2000BrandContractItem
                                              )
                                            )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("b-th", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "insert.investmentForm.total"
                                              )
                                            )
                                          )
                                        ])
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-tbody",
                                    [
                                      _c(
                                        "b-tr",
                                        [
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.investmentForm.targetedAverageMonthlySales"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "b-td",
                                            [
                                              _c("NextInput", {
                                                attrs: {
                                                  type: "number",
                                                  min: 0
                                                },
                                                model: {
                                                  value:
                                                    _vm.targetSale
                                                      .kentMonthlyAverageSales,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.targetSale,
                                                      "kentMonthlyAverageSales",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "targetSale.kentMonthlyAverageSales"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-td",
                                            [
                                              _c("NextInput", {
                                                attrs: {
                                                  type: "number",
                                                  min: 0
                                                },
                                                model: {
                                                  value:
                                                    _vm.targetSale
                                                      .rothmansMonthlyAverageSales,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.targetSale,
                                                      "rothmansMonthlyAverageSales",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "targetSale.rothmansMonthlyAverageSales"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-td",
                                            [
                                              _c("NextInput", {
                                                attrs: {
                                                  type: "number",
                                                  min: 0
                                                },
                                                model: {
                                                  value:
                                                    _vm.targetSale
                                                      .tekelMonthlyAverageSales,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.targetSale,
                                                      "tekelMonthlyAverageSales",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "targetSale.tekelMonthlyAverageSales"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-td",
                                            [
                                              _c("NextInput", {
                                                attrs: {
                                                  type: "number",
                                                  disabled: true
                                                },
                                                model: {
                                                  value:
                                                    _vm.totalTargetedAverageMonthlySales,
                                                  callback: function($$v) {
                                                    _vm.totalTargetedAverageMonthlySales = $$v
                                                  },
                                                  expression:
                                                    "totalTargetedAverageMonthlySales"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-tr",
                                        [
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.investmentForm.targetAnnualSalesProfit"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "b-td",
                                            [
                                              _c("NextInput", {
                                                attrs: {
                                                  type: "number",
                                                  disabled: true
                                                },
                                                model: {
                                                  value:
                                                    _vm.totalTargetAnnualSalesProfitKent,
                                                  callback: function($$v) {
                                                    _vm.totalTargetAnnualSalesProfitKent = $$v
                                                  },
                                                  expression:
                                                    "totalTargetAnnualSalesProfitKent"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-td",
                                            [
                                              _c("NextInput", {
                                                attrs: {
                                                  type: "number",
                                                  disabled: true
                                                },
                                                model: {
                                                  value:
                                                    _vm.totalTargetAnnualSalesProfitRothmans,
                                                  callback: function($$v) {
                                                    _vm.totalTargetAnnualSalesProfitRothmans = $$v
                                                  },
                                                  expression:
                                                    "totalTargetAnnualSalesProfitRothmans"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-td",
                                            [
                                              _c("NextInput", {
                                                attrs: {
                                                  type: "number",
                                                  disabled: true
                                                },
                                                model: {
                                                  value:
                                                    _vm.totalTargetAnnualSalesProfitTekel,
                                                  callback: function($$v) {
                                                    _vm.totalTargetAnnualSalesProfitTekel = $$v
                                                  },
                                                  expression:
                                                    "totalTargetAnnualSalesProfitTekel"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-td",
                                            [
                                              _c("NextInput", {
                                                attrs: {
                                                  type: "number",
                                                  disabled: true
                                                },
                                                model: {
                                                  value:
                                                    _vm.totalTargetAnnualSalesProfit,
                                                  callback: function($$v) {
                                                    _vm.totalTargetAnnualSalesProfit = $$v
                                                  },
                                                  expression:
                                                    "totalTargetAnnualSalesProfit"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "fieldset",
                    { staticClass: "fs-border" },
                    [
                      _c("legend", { staticClass: "fs-legend-detail" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("insert.investmentForm.newInvestmentBudget")
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "p-3" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "b-table-simple",
                                { attrs: { bordered: "", small: "" } },
                                [
                                  _c(
                                    "b-thead",
                                    [
                                      _c("b-th", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "insert.investmentForm.contractGainType"
                                              )
                                            )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("b-th", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "insert.investmentForm.earningAmount"
                                              )
                                            )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("b-th", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "insert.investmentForm.earningsTypeBudget"
                                              )
                                            )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("b-th", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "insert.contract.plannedPaymentDate"
                                              )
                                            )
                                          )
                                        ])
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-tbody",
                                    [
                                      _c(
                                        "b-tr",
                                        [
                                          _c("b-td", [_vm._v("Nakit")]),
                                          _vm._v(" "),
                                          _c(
                                            "b-td",
                                            [
                                              _c("NextInput", {
                                                attrs: {
                                                  type: "number",
                                                  min: 0
                                                },
                                                model: {
                                                  value:
                                                    _vm.newInvestmentBudgetCash
                                                      .Cash,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newInvestmentBudgetCash,
                                                      "Cash",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newInvestmentBudgetCash.Cash"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-td",
                                            [
                                              _c("NextDropdown", {
                                                attrs: {
                                                  label: "CustomerDesc",
                                                  source: _vm.customerBudgets
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.getCustomerBudget(
                                                      $event,
                                                      1
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.newInvestmentBudgetCash
                                                      .cashBudgetMaster,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newInvestmentBudgetCash,
                                                      "cashBudgetMaster",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newInvestmentBudgetCash.cashBudgetMaster"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-td",
                                            [
                                              _c("NextDatePicker", {
                                                model: {
                                                  value:
                                                    _vm.newInvestmentBudgetCash
                                                      .cashScheduledPaymentDate,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newInvestmentBudgetCash,
                                                      "cashScheduledPaymentDate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newInvestmentBudgetCash.cashScheduledPaymentDate"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-tr",
                                        [
                                          _c("b-td", [_vm._v("Only DTI")]),
                                          _vm._v(" "),
                                          _c(
                                            "b-td",
                                            [
                                              _c("NextInput", {
                                                attrs: {
                                                  type: "number",
                                                  min: 0
                                                },
                                                model: {
                                                  value:
                                                    _vm.newInvestmentBudgetDTI
                                                      .OnlyDTI,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newInvestmentBudgetDTI,
                                                      "OnlyDTI",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newInvestmentBudgetDTI.OnlyDTI"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-td",
                                            [
                                              _c("NextDropdown", {
                                                attrs: {
                                                  label: "CustomerDesc",
                                                  source: _vm.customerBudgets
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.getCustomerBudget(
                                                      $event,
                                                      2
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.newInvestmentBudgetDTI
                                                      .onlyDtiBudgetMaster,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newInvestmentBudgetDTI,
                                                      "onlyDtiBudgetMaster",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newInvestmentBudgetDTI.onlyDtiBudgetMaster"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-td",
                                            [
                                              _c("NextDatePicker", {
                                                attrs: { disabled: true },
                                                model: {
                                                  value:
                                                    _vm.newInvestmentBudgetDTI
                                                      .onlyDtiScheduledPaymentDate,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newInvestmentBudgetDTI,
                                                      "onlyDtiScheduledPaymentDate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newInvestmentBudgetDTI.onlyDtiScheduledPaymentDate"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-tr",
                                        [
                                          _c("b-td", [_vm._v("YYM")]),
                                          _vm._v(" "),
                                          _c(
                                            "b-td",
                                            [
                                              _c("NextInput", {
                                                attrs: {
                                                  type: "number",
                                                  min: 0
                                                },
                                                model: {
                                                  value:
                                                    _vm.newInvestmentBudgetYYM
                                                      .Yym,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newInvestmentBudgetYYM,
                                                      "Yym",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newInvestmentBudgetYYM.Yym"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-td",
                                            [
                                              _c("NextDropdown", {
                                                attrs: {
                                                  label: "CustomerDesc",
                                                  source: _vm.customerBudgets
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.getCustomerBudget(
                                                      $event,
                                                      3
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.newInvestmentBudgetYYM
                                                      .yymBudgetMaster,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newInvestmentBudgetYYM,
                                                      "yymBudgetMaster",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newInvestmentBudgetYYM.yymBudgetMaster"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-td",
                                            [
                                              _c("NextDatePicker", {
                                                attrs: { disabled: true },
                                                model: {
                                                  value:
                                                    _vm.newInvestmentBudgetYYM
                                                      .yymScheduledPaymentDate,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newInvestmentBudgetYYM,
                                                      "yymScheduledPaymentDate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "newInvestmentBudgetYYM.yymScheduledPaymentDate"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-tr",
                                        [
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.investmentForm.total"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _c(
                                              "span",
                                              [
                                                _c(
                                                  "b-td",
                                                  [
                                                    _c("NextInput", {
                                                      attrs: {
                                                        type: "number",
                                                        disabled: true
                                                      },
                                                      model: {
                                                        value: _vm.totalBudgets,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.totalBudgets = $$v
                                                        },
                                                        expression:
                                                          "totalBudgets"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td"),
                                          _vm._v(" "),
                                          _c("b-td")
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "fieldset",
                    { staticClass: "fs-border" },
                    [
                      _c("legend", { staticClass: "fs-legend-detail" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "insert.investmentForm.newReturnOfInvestment"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "p-3" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "b-table-simple",
                                { attrs: { bordered: "", small: "" } },
                                [
                                  _c(
                                    "b-tbody",
                                    [
                                      _c(
                                        "b-tr",
                                        [
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.investmentForm.expectedProfitability"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "b-td",
                                            [
                                              _c("NextInput", {
                                                attrs: {
                                                  type: "number",
                                                  disabled: true
                                                },
                                                model: {
                                                  value:
                                                    _vm.totalExpectedProfitability,
                                                  callback: function($$v) {
                                                    _vm.totalExpectedProfitability = $$v
                                                  },
                                                  expression:
                                                    "totalExpectedProfitability"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-tr",
                                        [
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.investmentForm.expectedReturnOnInvestment"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "b-td",
                                            [
                                              _c("NextInput", {
                                                attrs: {
                                                  type: "number",
                                                  disabled: true
                                                },
                                                model: {
                                                  value:
                                                    _vm.totalReturnOnInvestment,
                                                  callback: function($$v) {
                                                    _vm.totalReturnOnInvestment = $$v
                                                  },
                                                  expression:
                                                    "totalReturnOnInvestment"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("insert.investmentForm.unitAndOrderDetails")
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.tabValidation()
                    }
                  }
                },
                [
                  _c(
                    "fieldset",
                    { staticClass: "fs-border" },
                    [
                      _c("legend", { staticClass: "fs-legend-detail" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("insert.investmentForm.currentUnitStatus")
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "p-3" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "b-table-simple",
                                { attrs: { bordered: "", small: "" } },
                                [
                                  _c(
                                    "b-thead",
                                    [
                                      _c("b-th", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "insert.investmentForm.Units"
                                              )
                                            )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("b-th", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "insert.investmentForm.unitName"
                                              )
                                            )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("b-th", [
                                        _c("span", [
                                          _vm._v(_vm._s("Önyüz Sayısı"))
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("b-th", [
                                        _c("span", [
                                          _vm._v(_vm._s("Mobilya Masrafı"))
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("b-th", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "insert.investmentForm.piece"
                                              )
                                            )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("b-th", [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "insert.investmentForm.location"
                                              )
                                            )
                                          )
                                        ])
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-tbody",
                                    _vm._l(_vm.form.data, function(
                                      item,
                                      index
                                    ) {
                                      return _c(
                                        "b-tr",
                                        { key: index },
                                        [
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.investmentForm.unit"
                                                ) +
                                                  (index + 1)
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(_vm._s(item.Description1))
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "b-td",
                                            [
                                              item.ShelfQuantity != null
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(item.ShelfQuantity)
                                                    )
                                                  ])
                                                : _c("NextInput", {
                                                    attrs: { type: "number" },
                                                    model: {
                                                      value: item.ShelfQuantity,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "ShelfQuantity",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "item.ShelfQuantity"
                                                    }
                                                  })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-td",
                                            [
                                              item.FurnitureExpense != null
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.FurnitureExpense
                                                      )
                                                    )
                                                  ])
                                                : _c("NextInput", {
                                                    attrs: { type: "number" },
                                                    model: {
                                                      value:
                                                        item.FurnitureExpense,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "FurnitureExpense",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "item.FurnitureExpense"
                                                    }
                                                  })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                item.AssetLocations[0].Quantity
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                item.AssetLocations[0].Customer
                                                  .Label
                                              )
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "fieldset",
                    { staticClass: "fs-border" },
                    [
                      _c("legend", { staticClass: "fs-legend-detail" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("insert.investmentForm.opponentUnitStatus")
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "p-3" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "b-table-simple",
                                { attrs: { bordered: "", small: "" } },
                                [
                                  _c(
                                    "b-thead",
                                    [
                                      _c("b-th", [
                                        _c("span", [_vm._v("Firma")])
                                      ]),
                                      _vm._v(" "),
                                      _c("b-th", [_c("span", [_vm._v("PMI")])]),
                                      _vm._v(" "),
                                      _c("b-th", [_c("span", [_vm._v("JTI")])]),
                                      _vm._v(" "),
                                      _c("b-th", [_c("span", [_vm._v("ITC")])])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-tbody",
                                    [
                                      _c(
                                        "b-tr",
                                        [
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.investmentForm.unit"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "b-td",
                                            [
                                              _c("NextDropdown", {
                                                attrs: {
                                                  label: "Label",
                                                  source: _vm.IsUnit
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.getUnitAvailable(
                                                      $event,
                                                      1
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.opponentUnitStatus
                                                      .pmiUnit,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.opponentUnitStatus,
                                                      "pmiUnit",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "opponentUnitStatus.pmiUnit"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-td",
                                            [
                                              _c("NextDropdown", {
                                                attrs: {
                                                  label: "Label",
                                                  source: _vm.IsUnit
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.getUnitAvailable(
                                                      $event,
                                                      2
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.opponentUnitStatus
                                                      .jtiUnit,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.opponentUnitStatus,
                                                      "jtiUnit",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "opponentUnitStatus.jtiUnit"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-td",
                                            [
                                              _c("NextDropdown", {
                                                attrs: {
                                                  label: "Label",
                                                  source: _vm.IsUnit
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.getUnitAvailable(
                                                      $event,
                                                      3
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.opponentUnitStatus
                                                      .itcUnit,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.opponentUnitStatus,
                                                      "itcUnit",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "opponentUnitStatus.itcUnit"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-tr",
                                        [
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.investmentForm.unitType"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "b-td",
                                            [
                                              _c("NextDropdown", {
                                                attrs: {
                                                  disabled:
                                                    _vm.opponentUnitStatus
                                                      .pmiUnit &&
                                                    _vm.opponentUnitStatus
                                                      .pmiUnit.DecimalValue ===
                                                      0,
                                                  "lookup-key":
                                                    "OPPONENT_ASSET_TYPE",
                                                  "get-lookup": true
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.getUnitTypeSize(
                                                      $event,
                                                      1
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.opponentUnitStatus
                                                      .pmiUnitType,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.opponentUnitStatus,
                                                      "pmiUnitType",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "opponentUnitStatus.pmiUnitType"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-td",
                                            [
                                              _c("NextDropdown", {
                                                attrs: {
                                                  disabled:
                                                    _vm.opponentUnitStatus
                                                      .jtiUnit &&
                                                    _vm.opponentUnitStatus
                                                      .jtiUnit.DecimalValue ===
                                                      0,
                                                  "lookup-key":
                                                    "OPPONENT_ASSET_TYPE",
                                                  "get-lookup": true
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.getUnitTypeSize(
                                                      $event,
                                                      2
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.opponentUnitStatus
                                                      .jtiUnitType,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.opponentUnitStatus,
                                                      "jtiUnitType",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "opponentUnitStatus.jtiUnitType"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-td",
                                            [
                                              _c("NextDropdown", {
                                                attrs: {
                                                  disabled:
                                                    _vm.opponentUnitStatus
                                                      .itcUnit &&
                                                    _vm.opponentUnitStatus
                                                      .itcUnit.DecimalValue ===
                                                      0,
                                                  "lookup-key":
                                                    "OPPONENT_ASSET_TYPE",
                                                  "get-lookup": true
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.getUnitTypeSize(
                                                      $event,
                                                      3
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.opponentUnitStatus
                                                      .itcUnitType,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.opponentUnitStatus,
                                                      "itcUnitType",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "opponentUnitStatus.itcUnitType"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-tr",
                                        [
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.investmentForm.investmentAmount"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "b-td",
                                            [
                                              _c("NextInput", {
                                                attrs: {
                                                  disabled:
                                                    _vm.opponentUnitStatus
                                                      .pmiUnit &&
                                                    _vm.opponentUnitStatus
                                                      .pmiUnit.DecimalValue ===
                                                      0,
                                                  type: "number",
                                                  min: 0
                                                },
                                                model: {
                                                  value:
                                                    _vm.opponentUnitStatus
                                                      .pmiInvestmentAmount,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.opponentUnitStatus,
                                                      "pmiInvestmentAmount",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "opponentUnitStatus.pmiInvestmentAmount"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-td",
                                            [
                                              _c("NextInput", {
                                                attrs: {
                                                  disabled:
                                                    _vm.opponentUnitStatus
                                                      .jtiUnit &&
                                                    _vm.opponentUnitStatus
                                                      .jtiUnit.DecimalValue ===
                                                      0,
                                                  type: "number",
                                                  min: 0
                                                },
                                                model: {
                                                  value:
                                                    _vm.opponentUnitStatus
                                                      .jtiInvestmentAmount,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.opponentUnitStatus,
                                                      "jtiInvestmentAmount",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "opponentUnitStatus.jtiInvestmentAmount"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-td",
                                            [
                                              _c("NextInput", {
                                                attrs: {
                                                  disabled:
                                                    _vm.opponentUnitStatus
                                                      .itcUnit &&
                                                    _vm.opponentUnitStatus
                                                      .itcUnit.DecimalValue ===
                                                      0,
                                                  type: "number",
                                                  min: 0
                                                },
                                                model: {
                                                  value:
                                                    _vm.opponentUnitStatus
                                                      .itcInvestmentAmount,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.opponentUnitStatus,
                                                      "itcInvestmentAmount",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "opponentUnitStatus.itcInvestmentAmount"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "fieldset",
                    { staticClass: "fs-border" },
                    [
                      _c("legend", { staticClass: "fs-legend-detail" }, [
                        _vm._v(
                          _vm._s(_vm.$t("insert.investmentForm.otherDetails"))
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "p-3" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "b-table-simple",
                                { attrs: { bordered: "", small: "" } },
                                [
                                  _c(
                                    "b-tbody",
                                    [
                                      _c(
                                        "b-tr",
                                        [
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.investmentForm.furniteCost"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "b-td",
                                            [
                                              _c("NextInput", {
                                                attrs: {
                                                  type: "number",
                                                  disabled: true
                                                },
                                                model: {
                                                  value:
                                                    _vm.otherDetails
                                                      .furniteCost,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.otherDetails,
                                                      "furniteCost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "otherDetails.furniteCost"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-tr",
                                        [
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.investmentForm.numberOfFrontFaces"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "b-td",
                                            [
                                              _c("NextInput", {
                                                attrs: {
                                                  type: "number",
                                                  disabled: true
                                                },
                                                model: {
                                                  value:
                                                    _vm.otherDetails
                                                      .numberOfFrontFaces,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.otherDetails,
                                                      "numberOfFrontFaces",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "otherDetails.numberOfFrontFaces"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-tr",
                                        [
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.investmentForm.frontFaceCost"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "b-td",
                                            [
                                              _c("NextInput", {
                                                attrs: {
                                                  type: "number",
                                                  disabled: true
                                                },
                                                model: {
                                                  value:
                                                    _vm.otherDetails
                                                      .totalFrontFaceCost,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.otherDetails,
                                                      "totalFrontFaceCost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "otherDetails.totalFrontFaceCost"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-tr",
                                        [
                                          _c("b-td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "insert.investmentForm.totalFurniteCost"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "b-td",
                                            [
                                              _c("NextInput", {
                                                attrs: {
                                                  type: "number",
                                                  disabled: true
                                                },
                                                model: {
                                                  value:
                                                    _vm.otherDetails
                                                      .totalFurniteCost,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.otherDetails,
                                                      "totalFurniteCost",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "otherDetails.totalFurniteCost"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4faeb32d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4faeb32d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/InvestmentForm/update.vue
// module id = null
// module chunks = 